import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Collapsable from 'library/components/collapsable';
import CaretSvg from 'library/icons/caret.svg';
import AudioButton from 'library/components/audio-button';

const LANGUAGE_MAP = {
  'en': true,
  'es': true
};

class AdjectiveBody extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    audio_key: PropTypes.string,
    definition: PropTypes.string,
    checked: PropTypes.bool
  }

  state = {
    collapsed: true
  }

  handleClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({collapsed: !this.state.collapsed});
  }

  render() {
    const {
      name,
      definition,
      audio_key,
      checked
    } = this.props;
    const {
      collapsed
    } = this.state;

    const checkedString = checked ? 'checked' : 'unchecked';
    const inverseCheckedString = checked ? 'unchecked' : 'checked';

    return (
      <Fragment>
        <div className="survey-version-list-row-body">
          <div className="survey-version-list-row-header" onClick={this.handleClicked}>
            {
              LANGUAGE_MAP[`${__LANGUAGE__}`]
                ? (
                  <AudioButton
                    src={`${__ASSET_PATH__}/audio/${__LANGUAGE__}/${audio_key}`}
                    className="survey-version-list-row-audio"
                    component="a"
                    aria-label={`Play Audio: ${name}`}
                    href="javascript:void(0)"
                  />
                )
                : null
            }
            <input aria-label={`${name} is now ${checkedString}, Definition: ${name, definition}, press shift + tab + tab + space to ${inverseCheckedString} the check box  or tab to continue to the next adjective`}
              className="survey-version-list-row-body-checkbox hidden-accessibility-checkbox"
              type="checkbox"
              onChange={this.handleClicked}
            />
            <span className="survey-version-list-row-name">{ name }</span>
            <CaretSvg className={['rotate-180', !collapsed?'active':''].filter(c=>c).join(' ')}  />
          </div>
          <Collapsable className="survey-version-list-row-collapsable" collapsed={collapsed}>
            <div className="survey-version-list-row-definition">
              { definition }
            </div>
          </Collapsable>
        </div>
      </Fragment>
    );
  }
}

export default AdjectiveBody;
